import React, { Component } from 'react';
import { connect } from 'react-redux';

import FlatButton from "material-ui/FlatButton";
import TextField from 'material-ui/TextField/TextField';
import { Card } from "material-ui/Card";
import ViewTitle from "components/layout/ViewTitle";

import * as utils from "./utils";
import {
  importFoodyMenuToOcha as importFoodyMenuToOchaAction
} from 'actions';


class ImportFoodyMenu extends Component {
  state = {
    shopId: '',
  };

  constructor(props) {
    super(props);
    this.onClickSaveButton = this.onClickSaveButton.bind(this);
    this.handleShopId = this.handleShopId.bind(this);
  }

  onClickSaveButton() {
    const data = {
      shop_id: parseInt(this.state.shopId, 10),
      object_types: utils.FOODY_MENU_OBJECT_LIST.map(menuObj => menuObj.id),
    };
    this.props.dispatch(importFoodyMenuToOchaAction(data));
  }

  handleShopId(value) {
    this.setState({
      shopId: value
    });
  }

  render() {
    return (
      <div className="list-page">
        <Card style={{padding: '5px'}}>
          <ViewTitle title='Import Foody menu into Ocha'/>

          <div style={{padding: '20px'}}>
            <TextField
              floatingLabelText={'Shop ID'}
              value={this.state.shopId}
              onChange={(event, newValue) => this.handleShopId(newValue)}
            />
            <br/>
          </div>
          <br/>
          <FlatButton
            primary label='Import'
            style={{
              margin: '5px 12px',
              position: 'relative',
            }}
            disabled={!this.state.shopId || isNaN(this.state.shopId)}
            onClick={this.onClickSaveButton}
          />
        </Card>
      </div>
    )
  }
}


export default connect()(ImportFoodyMenu);




// WEBPACK FOOTER //
// ./src/routes/advancedFunction/ImportFoodyMenu.js